import { IAppState } from '../../redux';
import { getJKRegions } from '../../utils/jk';
import { selectIsNewbuildingSaleCategory, selectLocationsFromAddress } from '../offer';
import { selectIsJKSelected } from './selectIsJKSelected';

export const selectIsAddJKState = (state: IAppState) => {
  const isJKCategory = selectIsNewbuildingSaleCategory(state);
  const locations = selectLocationsFromAddress(state);
  const isJKSelected = selectIsJKSelected(false, state);

  const shouldSelectJK = getJKRegions().some(id => locations.includes(id));

  return isJKCategory && shouldSelectJK && !isJKSelected;
};
